import clsx from 'clsx';
import { buttonProps } from '../../utils/types';
import './index.scss';
import { CircularProgress } from '@mui/material';

export function Button({
  variant = 'button--primary',
  children,
  className,
  disabled,
  isLoading,
  ...restProps
}: buttonProps) {
  className = clsx(
    'button',
    variant,
    className,
    disabled ? 'button--disabled' : ''
  );

  return (
    <button
      {...restProps}
      className={className}
      disabled={disabled}>
      <div className="flex items-center gap-2">
        {children}
        {isLoading && (
          <CircularProgress
            color="inherit"
            thickness={5}
            style={{ width: 16, height: 16 }}
          />
        )}
      </div>
    </button>
  );
}
